<li class="service-list-item">
    <div class="service-list-item__icon">
        <img [src]="imgPath" alt="alt-name">
    </div>
    <div class="service-list-item__text">
        {{serviceText}}
    </div>
</li>